import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {computed} from 'vue';
import ErrorDisplay from './ErrorDisplay.vue';
import {storeMap} from '@/plugins/piniaStoreById';


export default /*#__PURE__*/_defineComponent({
  __name: 'Error',
  props: {
  module: {
    type: String,
    required: true,
    default: () => null,
  },
},
  setup(__props, { expose: __expose }) {

const props = __props;

const storeFromId = storeMap.get(props.module);

const error = computed((): Error|null => {
  if (!storeFromId) return null;
  return storeFromId.error;
});

const loading =computed((): boolean => {
  if (!storeFromId) return true;
  return storeFromId.loading;
});
async function reloadStorageData() {
  if (storeFromId) {
    await storeFromId!.fetch();
  }
}

__expose({
  error,
  loading,
  reloadStorageData,
  ErrorDisplay,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ErrorDisplay, {
    message: error.value?.message,
    onRetry: reloadStorageData,
    loading: loading.value
  }, null, 8, ["message", "loading"]))
}
}

})